import SelfConnectionRules from './SelfConnectionRules';

export default {
  __init__: ['SelfConnectionRules'],
  SelfConnectionRules: ['type', SelfConnectionRules],
};
